import { Component } from '@angular/core';

@Component({
  selector: 'app-vaids-carousel-slide',
  templateUrl: './vaids-carousel-slide.component.html',
  styleUrls: ['./vaids-carousel-slide.component.css']
})
export class VaidsCarouselSlideComponent {

}
